"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var undoActions = require("owa-mail-undo");
var copyMailListRows_1 = require("./copyMailListRows");
var deleteMailListRows_1 = require("../deleteMailListRows");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var handleBlockActionForShadowMailbox_1 = require("./handleBlockActionForShadowMailbox");
var Store_1 = require("owa-mail-store/lib/store/Store");
var getMoveKind_1 = require("./getMoveKind");
var owa_mail_actions_1 = require("owa-mail-actions");
var owa_mail_move_mru_1 = require("owa-mail-move-mru");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Move rows from table action
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
exports.default = legacy_1.select({
    sourceFolder: function (rowKeys, destinationFolderId, originalTableView) {
        return Store_1.default.folders.folderTable.get(originalTableView.tableQuery.folderId);
    },
    destinationFolder: function (rowKeys, destinationFolderId, originalTableView) { return Store_1.default.folders.folderTable.get(destinationFolderId); },
    isUserShadowMailbox: function () { return getUserConfiguration_1.default().SessionSettings.IsShadowMailbox; },
})(function moveMailListRowsHelper(rowKeys, destinationFolderId, originalTableView, moveRowsInternal, actionSource, state) {
    var sourceFolder = state.sourceFolder, destinationFolder = state.destinationFolder, isUserShadowMailbox = state.isUserShadowMailbox;
    var moveKind = getMoveKind_1.default(isUserShadowMailbox, sourceFolder, destinationFolder);
    var sourceFolderId = originalTableView.tableQuery.folderId;
    if (handleBlockActionForShadowMailbox_1.default(sourceFolderId, destinationFolderId)) {
        return;
    }
    undoActions.clearLastUndoableAction();
    // Since row may have been deleted because moveRows is an lazy action,
    // we need to validate the row keys again before performing move
    // Here we cannot compare destinationFolderId with sourceFolderId, because sourceFolderId is null in Search,
    // so we need to get the actual parentFolderId of each row
    var filteredRowKeys = rowKeys.filter(function (rowKey) {
        return originalTableView.rowKeys.indexOf(rowKey) >= 0 &&
            destinationFolderId !=
                owa_mail_list_store_1.MailRowDataPropertyGetter.getParentFolderId(rowKey, originalTableView);
    });
    var instrumentationContexts = [];
    var isSearch = originalTableView.tableQuery.type == 1 /* Search */;
    if (isSearch) {
        filteredRowKeys.forEach(function (rowKey) {
            var instrumentationContext = owa_mail_list_store_1.MailRowDataPropertyGetter.getInstrumentationContext(rowKey, originalTableView);
            if (instrumentationContext) {
                instrumentationContexts.push(instrumentationContext);
            }
        });
    }
    // We do not have any conversations that can be moved
    if (filteredRowKeys.length == 0) {
        return;
    }
    var promiseToReturn;
    switch (moveKind) {
        case 2 /* ShadowMailbox_Delete */:
            // if we are in a ShadowMailbox and actually need to perform a delete,
            // we call the deleteConversations action directly, which handles its own
            // service and undo operation
            return deleteMailListRows_1.default(filteredRowKeys, originalTableView.id, false);
        case 1 /* ShadowMailbox_Copy */:
            promiseToReturn = copyMailListRows_1.default(filteredRowKeys, originalTableView, destinationFolderId, sourceFolderId);
            break;
        case 0 /* Normal */:
        default:
            // Update Move to mru list
            owa_mail_move_mru_1.lazyAddFolderIdToMoveToMruList.importAndExecute(destinationFolderId);
            // Make service request
            // Task 658: Reload client state when move conversation fails on the server.
            promiseToReturn = moveRowsInternal(filteredRowKeys, destinationFolderId, originalTableView, sourceFolderId);
            break;
    }
    owa_mail_actions_1.userMailInteractionAction('Move', instrumentationContexts);
    return promiseToReturn;
});
//# sourceMappingURL=moveMailListRowsHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/moveMailListRowsHelper.js
// module id = 3820
// module chunks = 62